import Forbidden from 'containers/Forbidden'
import { CompanyModuleAccessDto } from 'data/dtos/CompanyModuleAccessDto'
import React from 'react'
import { Route, RouteProps, RouteComponentProps, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { IRootReduxState } from 'types/reducers'

interface IProps {
  access: CompanyModuleAccessDto
}
export const ProtectedRoute: React.FC<IProps & RouteProps> = ({ access, render, ...rest }) => {
  const user = useSelector((state: IRootReduxState) => state.oidc.user)
  const accessLoaded = useSelector((state: IRootReduxState) => state.app.user.accessLoaded)

  const checkAuth = (routeProps: RouteComponentProps) => {
    if (!user || user.expired) {
      return <Redirect to="/" />
    }
    if (!access.AccessAllowed) {
      if (!accessLoaded) {
        return (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
            <div style={{ width: 36, height: 36, border: '3px solid #e0e0e0', borderTop: '3px solid #2d7dd2', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
            <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
          </div>
        )
      }
      return <Forbidden />
    }
    if (!render) {
      return null
    }
    return render(routeProps)
  }
  return <Route render={checkAuth} {...rest} />
}
export default ProtectedRoute